'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dLogin$002dMode$0024$0024anon$002480 from "./presto.types$-Login-Mode$$anon$80.js";
var $p;
function $s_Lpresto_types$LoginMode$__up__Lpresto_types$LoginMode() {
  $m_Lpresto_types$LoginMode$();
  return $t_Lpresto_types$LoginMode$__up;
}
export { $s_Lpresto_types$LoginMode$__up__Lpresto_types$LoginMode as $s_Lpresto_types$LoginMode$__up__Lpresto_types$LoginMode };
function $s_Lpresto_types$LoginMode$__saml__Lpresto_types$LoginMode() {
  $m_Lpresto_types$LoginMode$();
  return $t_Lpresto_types$LoginMode$__saml;
}
export { $s_Lpresto_types$LoginMode$__saml__Lpresto_types$LoginMode as $s_Lpresto_types$LoginMode$__saml__Lpresto_types$LoginMode };
/** @constructor */
function $c_Lpresto_types$LoginMode$() {
  this.c85 = null;
  this.c86 = false;
  $n_Lpresto_types$LoginMode$ = this;
  $t_Lpresto_types$LoginMode$__up = new $j_presto$002etypes$0024$002dLogin$002dMode$0024$0024anon$002480.$c_Lpresto_types$LoginMode$$anon$80(0, "up", this);
  $t_Lpresto_types$LoginMode$__saml = new $j_presto$002etypes$0024$002dLogin$002dMode$0024$0024anon$002480.$c_Lpresto_types$LoginMode$$anon$80(1, "saml", this);
  $s_Lpresto_types$LoginMode$__up__Lpresto_types$LoginMode();
  $s_Lpresto_types$LoginMode$__saml__Lpresto_types$LoginMode();
}
export { $c_Lpresto_types$LoginMode$ as $c_Lpresto_types$LoginMode$ };
$p = $c_Lpresto_types$LoginMode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$LoginMode$;
/** @constructor */
function $h_Lpresto_types$LoginMode$() {
}
export { $h_Lpresto_types$LoginMode$ as $h_Lpresto_types$LoginMode$ };
$h_Lpresto_types$LoginMode$.prototype = $p;
$p.cR5 = (function(\u03b4name) {
  if ((\u03b4name === "up")) {
    return $s_Lpresto_types$LoginMode$__up__Lpresto_types$LoginMode();
  }
  if ((\u03b4name === "saml")) {
    return $s_Lpresto_types$LoginMode$__saml__Lpresto_types$LoginMode();
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
});
$p.cHS = (function() {
  if ((!this.c86)) {
    this.c85 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$LoginMode$().cR5(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c86 = true;
  }
  return this.c85;
});
var $d_Lpresto_types$LoginMode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$LoginMode$, "presto.types$LoginMode$", ({
  a0C: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$LoginMode$ as $d_Lpresto_types$LoginMode$ };
var $n_Lpresto_types$LoginMode$;
function $m_Lpresto_types$LoginMode$() {
  if ((!$n_Lpresto_types$LoginMode$)) {
    $n_Lpresto_types$LoginMode$ = new $c_Lpresto_types$LoginMode$();
  }
  return $n_Lpresto_types$LoginMode$;
}
export { $m_Lpresto_types$LoginMode$ as $m_Lpresto_types$LoginMode$ };
var $t_Lpresto_types$LoginMode$__up = null;
function $u_Lpresto_types$LoginMode$__up(x) {
  $t_Lpresto_types$LoginMode$__up = x;
}
export { $t_Lpresto_types$LoginMode$__up as $t_Lpresto_types$LoginMode$__up, $u_Lpresto_types$LoginMode$__up as $u_Lpresto_types$LoginMode$__up };
var $t_Lpresto_types$LoginMode$__saml = null;
function $u_Lpresto_types$LoginMode$__saml(x) {
  $t_Lpresto_types$LoginMode$__saml = x;
}
export { $t_Lpresto_types$LoginMode$__saml as $t_Lpresto_types$LoginMode$__saml, $u_Lpresto_types$LoginMode$__saml as $u_Lpresto_types$LoginMode$__saml };
//# sourceMappingURL=presto.types$-Login-Mode$.js.map
